const headers = {
  name: "References",
  navigate: {
    path: [
      {
        name: "References",
        path: "/app/customers/refrences",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
